<template>
  <div
    class="medical-record-item lightGray d-flex align-center -space-between"
    :class="!hasName ? 'd-flex align-center justify-space-between' : ''"
  >
    <div v-if="hasName">
      {{ medicalRecord.patient.name }}
    </div>
    <div
      class="d-flex flex-row align-center justify-center mr-5"
      :class="!hasName ? '' : 'ml-auto'"
    >
      <v-icon size="32" color="primary" class="mr-1">date_range</v-icon>
      <p class="ma-0">{{ medicalRecord.date | formatDate }}</p>
    </div>
    <div class="d-flex align-center">
      <v-btn
        height="50"
        class="primary white--text rounded-l-0 rounded-0"
        :to="{
              name: 'FormProntuario',
              params: {
              idAppointment: medicalRecord.appointment.id,
              idMedicalRecord: medicalRecord.id,
              maker: false,
          },
        }"
      >
        <v-icon>visibility</v-icon>
      </v-btn>
      <v-btn
        height="50"
        class="primary white--text rounded-l-0 rounded-r"
        @click="exportDocx(medicalRecord)"
      >
        <v-icon>get_app</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { Document, Paragraph, Packer, TextRun, HeadingLevel } from 'docx';
import { saveAs } from 'file-saver';

export default {
  name: 'MedicalRecordItem',
  props: {
    medicalRecord: Object,

    hasName: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    exportDocx(medicalRecord) {
      // Create a new Document an save it in a variable
      const doc = new Document();

      // doc.addParagraph();
      doc.addSection({
        children: [
          new Paragraph({
            text: `Prontário de paciente: ${medicalRecord.patient.name}`,
            heading: HeadingLevel.TITLE,
          }),
          new Paragraph({
            text: `Data: ${moment(medicalRecord.date).format('DD/MM/YYYY')}`,
            heading: HeadingLevel.HEADING_2,
          }),
          new Paragraph({
            text: 'Formulário do prontuário:',
            heading: HeadingLevel.HEADING_3,
            spacing: {
              before: 500,
            },
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text: 'Queixa Principal: ',
                bold: true,
              }),
              new TextRun(medicalRecord.main_complaint),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text:
                  'Evolução da Queixa (COMO COMEÇOU/ FOI REPENTINO OU GRADUAL/ QUAIS TRANSFORMAÇÕES OCORRERAM OS SINTOMAS): ',
                bold: true,
              }),
              new TextRun(medicalRecord.evolution_complaint),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text: 'Diagnóstico Clinico: ',
                bold: true,
              }),
              new TextRun(medicalRecord.clinical_diagnosis),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text: 'Medicações: ',
                bold: true,
              }),
              new TextRun(medicalRecord.medication),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text: 'Histórico: ',
                bold: true,
              }),
              new TextRun(medicalRecord.history),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text: 'Profissão/Escolaridade: ',
                bold: true,
              }),
              new TextRun(medicalRecord.profession),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text: 'Religião: ',
                bold: true,
              }),
              new TextRun(medicalRecord.religion),
            ],
          }),
          new Paragraph({
            spacing: {
              before: 150,
            },
            children: [
              new TextRun({
                text:
                  'OUTROS (Registe aqui algo a mais que seja importante para a identificação do seu paciente): ',
                bold: true,
              }),
              new TextRun(medicalRecord.others),
            ],
          }),
        ],
      });

      // To export into a .docx file
      // const packer = new Packer();

      Packer.toBlob(doc).then((blob) => {
        saveAs(
          blob,
          `Prontuário ${medicalRecord.patient.name}_${moment(medicalRecord.date).format(
            'DD-MM-YYYY',
          )}.docx`,
        );
        this.$showSnackbar('Documento gerado com sucesso');
      });
    },
  },
};
</script>

<style lang="css" scoped>
.medical-record-item {
  background-color: #fff;
}

@media screen and (max-width: 420px) {
  .medical-record-item {
    background-color: #f9f9f9;
  }
}
</style>
